(function () {
  const PLAY_ICON = `<svg aria-hidden="true" width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.352539 1.98926C0.352539 0.890623 1.24316 0 2.3418 0C2.78168 0 3.20915 0.145798 3.55735 0.414589L13.4411 8.04427C14.4502 8.82321 14.4828 10.3347 13.5083 11.1564L3.566 19.5398C3.21358 19.837 2.76744 20 2.30645 20C1.22734 20 0.352539 19.1252 0.352539 18.0461V1.98926Z" fill="#D9D9D9"/>
    </svg>`;
  const PAUSE_ICON = `
    <svg aria-hidden="true" width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="5" height="20" rx="2.5" fill="#D9D9D9"/>
    <rect x="10" width="5" height="20" rx="2.5" fill="#D9D9D9"/>
    </svg>`;

  function wrapIfNeeded(video) {
    if (!video.closest(".a11y-media-wrapper")) {
      const wrap = document.createElement("div");
      wrap.className = "a11y-media-wrapper";
      video.parentNode.insertBefore(wrap, video);
      wrap.appendChild(video);
    }
  }

  function addButton(video) {
    if (video.dataset.a11yBtnAttached) return;
    video.dataset.a11yBtnAttached = "true";
    wrapIfNeeded(video);

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "a11y-media-btn";
    const isPaused = video.paused;
    btn.setAttribute("aria-pressed", String(!isPaused));
    btn.setAttribute("aria-label", isPaused ? "Play video" : "Pause video");
    btn.innerHTML = isPaused ? PLAY_ICON : PAUSE_ICON;

    // Ensure muted if it autoplays with audio
    if (video.autoplay && !video.muted) video.muted = true;

    btn.addEventListener("click", () => {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
      updateState();
    });

    video.addEventListener("play", updateState);
    video.addEventListener("pause", updateState);

    function updateState() {
      const paused = video.paused;
      btn.setAttribute("aria-pressed", String(!paused));
      btn.setAttribute("aria-label", paused ? "Play video" : "Pause video");
      btn.innerHTML = paused ? PLAY_ICON : PAUSE_ICON;
    }

    video.closest(".a11y-media-wrapper").appendChild(btn);
  }

  function eligible(v) {
    // Treat as autoplay if attribute present OR plays inline background (commonly no controls)
    return (
      (v.matches("video[autoplay], video.background-video, video.background-media, video.media") ||
        v.autoplay) &&
      !v.controls
    ); // skip videos already showing native controls
  }

  function init(root = document) {
    root.querySelectorAll("video").forEach((v) => {
      if (eligible(v)) addButton(v);
    });
  }

  // Initial
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  // Handle videos added later (sections, carousels)
  new MutationObserver((muts) => {
    muts.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.tagName === "VIDEO") {
            if (eligible(node)) addButton(node);
          } else {
            init(node);
          }
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
